export default __webpack_public_path__ + "static/media/october.061a8e15.md";